import {Component, Input} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {
  Country,
  EventItem, League,
  Lookups,
} from "@model";
import {AbstractComponent} from "../abstract.component";
import {DatePipe} from '@angular/common';
import {environment} from "@environment";

@Component({
  selector: 'app-league-grid-item-with-image',
  templateUrl: './league-grid-item-with-image.component.html',
  styleUrls: ['./league-grid-item-with-image.component.scss'],
  providers: [DatePipe]
})
export class LeagueGridItemWithImage extends AbstractComponent {
  @Input() league: League | undefined;
  @Input() additionalClass: string | undefined;
  @Input() isFinishedLeague: boolean = false;
  @Input() countries: Country[] = [];
  @Input() isOnWishList: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() favoriteItems?: EventItem[];
  @Input() isItemFavorite: boolean = false;
  @Input() isPreviewComponent?: boolean;
  @Input() zoomEffect: boolean = false;

  lengths: (string | undefined)[] = [];

  constructor(public translocoService: TranslocoService) {
    super();
  }

  protected readonly environment = environment;
}
